







































import { Component, Prop, Vue } from "vue-property-decorator";
import { Gender, RiskTextForScore } from "../model/Model";
import { Borough } from "../model/Boroughs";

@Component
export default class AmIAlcoholic extends Vue {
  public static navButtonClasses: string[] = ["am-i-alcoholic"];
  public static navButtonLabel: () => string = () => "Am I an alcoholic?";

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;

  private showContent: boolean = false;

  private toggleContent() {
    this.showContent = !this.showContent;
  }

  private get riskText(): string {
    return RiskTextForScore(this.score);
  }
}
